/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Media_Type_BusinessobjectInputs */

const en_enum_media_type_businessobject = /** @type {(inputs: Enum_Media_Type_BusinessobjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Businessobject`)
};

const de_enum_media_type_businessobject = /** @type {(inputs: Enum_Media_Type_BusinessobjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Businessobject`)
};

/**
* | output |
* | --- |
* | "Businessobject" |
*
* @param {Enum_Media_Type_BusinessobjectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_media_type_businessobject = /** @type {((inputs?: Enum_Media_Type_BusinessobjectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Media_Type_BusinessobjectInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_media_type_businessobject(inputs)
	return de_enum_media_type_businessobject(inputs)
});